import { createSelector } from 'reselect';
import { isInFullScreen } from 'shared/selectors/player';
import { MIN_INLINE_SHARE_THUMBNAIL_WIDTH } from 'widget/constants/sizes';
export var isInlineShareVisible = createSelector(function (state, props) { return props; }, isInFullScreen, function (props, isFullScreen) {
    return props.itemWidth > MIN_INLINE_SHARE_THUMBNAIL_WIDTH || isFullScreen;
});
